import { render, staticRenderFns } from "./Servicos.vue?vue&type=template&id=2705081a&scoped=true&"
import script from "./Servicos.vue?vue&type=script&lang=js&"
export * from "./Servicos.vue?vue&type=script&lang=js&"
import style0 from "./Servicos.vue?vue&type=style&index=0&id=2705081a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2705081a",
  null
  
)

export default component.exports